export default __webpack_public_path__ + "static/media/date.3739d774.svg";